import styled from "styled-components";

export default function LocalFileCard(props) {
    const { children, file } = props;

    return (
        <Styled>
            <span className="name">{ file.name }</span>
            <span className="size">{ file.size } b</span>
            <span className="last-modified">{ file.lastModifiedDate.toISOString() }</span>
            { children }
        </Styled>
    );
}

const Styled = styled.div`
    background: #fff;
    border-radius: 4px;
    display: grid;
    gap: 2px 8px;
    grid-auto-columns: min-content;
    grid-auto-flow: column;
    grid-template-columns: min-content 1fr;
    grid-template-rows: min-content min-content;
    padding: 8px 16px;

    .name {
        font-size: 1.2em;
        grid-column: 1 / 3;
    }

    .size {
        font-size: .8em;
        opacity: .6;
        white-space: nowrap;
    }

    .last-modified {
        font-size: .8em;
        opacity: .1;

        &:empty {
            display: none;
        }

        &::before {
            content: "Last modified: ";
        }
    }

    :nth-child(n+4) {
        grid-row: 1 / -1;
        align-self: center;
    }
`;
